import { KnmReasonTypeNameEnum } from 'KnmPackage/MainModule/enums/KnmReasonTypeNameEnum';

import { IKnmPmFormReason } from '../interfaces/IKnmPmFormReason';

export const isPlanKnm = (reasonFieldValue: IKnmPmFormReason | undefined) => {
  return reasonFieldValue?.ervkUuid != null && reasonFieldValue?.type?.name === KnmReasonTypeNameEnum.PV_INSTEAD_OF_KNM;
};
